// @flow
import React, { PureComponent } from 'react';
import { StyleSheet } from 'react-native';
import { SingleInputForm } from '../../../../../components/common';
import I18n from '../../../../../lib/i18n';

class PromotionCodePage extends PureComponent<Props> {
  styles = getStyles();
  render() {
    return (
      <SingleInputForm
        buttonText={I18n.t('SignUp.ConfirmPlan.promotionCode.button')}
        isLoading={this.props.isLoading}
        maxLength={15}
        name="code"
        onRequestClose={this.props.onRequestClose}
        onSubmitEditing={this.props.handleSubmit}
        style={this.styles}
        title={I18n.t('SignUp.ConfirmPlan.promotionCode.pageTitle')}
      />
    );
  }
}

type Props = {
  onRequestClose: () => void,
  handleSubmit?: () => void,
  isLoading: boolean,
};

const getStyles = () =>
  StyleSheet.create({
    inputContainer: {
      width: 300,
      alignSelf: 'center',
    },
  });

export default PromotionCodePage;
